
export const formatterArg = new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    maximumFractionDigits: 0,
});

export const round = (amount: number, decimals: number = 2) => Math.round(amount * Math.pow(10, decimals)) / Math.pow(10, decimals);